module.exports = __webpack_public_path__ + "img/icon_list_red.d9871a98.svg";